import React from "react";
import styled from "styled-components";
import { OpenGraphData } from "@domain/media/openGraphData";
import { BackgroundImage } from "@ui/components/backgroundImage";
import { Clamp } from "@ui/components/containers/clamp";
import { Primary } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { DeleteIcon, LinkIcon } from "@ui/components/icons";
import { row, stack } from "@ui/components/layout";
import { videoInfosFromUrl } from "@ui/components/media/utils";
import { VideoPlayer } from "@ui/components/media/videoPlayer";

interface PostOpenGraphEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	data: OpenGraphData;
	clearData?: () => void;
}
export const PostOpenGraphView: React.FC<PostOpenGraphEditorProps> = ({ data, clearData, ...htmlProps }) => {
	const videoId = videoInfosFromUrl(data.url)?.videoId;

	return (
		<Container {...htmlProps}>
			<a href={data.url} target="_blank" rel="noreferrer">
				<div>
					{videoId ? (
						<VideoPlayer source={data.url} />
					) : (
						data.image && (
							<OpenGraphImage
								defaultUrl={data.image.startsWith("https") ? data.image : (data.url + data.image).replace(/\/\//g, "/")}
							/>
						)
					)}
					<Infos>
						<Primary>
							<Clamp>
								<b>{data?.title}</b>
							</Clamp>
						</Primary>
						<Clamp>{data?.description}</Clamp>
						<Url>
							<LinkIcon />
							<Clamp size={1}>{data?.url}</Clamp>
						</Url>
					</Infos>
				</div>
			</a>
			{clearData && <DeleteIcon onClick={clearData} />}
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	overflow: hidden;
	position: relative;

	> svg {
		cursor: pointer;
		position: absolute;
		right: 0;
		top: 0;

		path {
			fill: ${({ theme }) => theme.colors.lightgray};
		}
	}
`;

const OpenGraphImage = styled(BackgroundImage)`
	padding-bottom: 52.25%; /* 1200/627px */
`;

const Infos = styled(Primary)`
	${stack(2)};
	padding: 8px 10px;
	color: ${({ theme }) => theme.colors.textSecondary};
`;

const Url = styled.div`
	${row(5, "flex-start", "center")}
	${({ theme }) => theme.textStyles.light};
	color: ${({ theme }) => theme.colors.textSecondary};

	> svg {
		width: 12px;
		flex-shrink: 0;
	}
`;
